@if ($model() != null) {
    <div class="wrapper px-1">
        @if (Utils.isNotNullOrEmpty($publicMessageHtml())) {
            <div class="public-message py-1"
                 [class.loading]="$isPublicMessageHtmlLoading()"
                 [safeHtmlContent]="$publicMessageHtml()"
            >{{Enums.Messages.DefaultLoadingText}}</div>
        } @else {
            <div><span>Fluxo <b>encerrado</b></span></div>
        }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
